import Vue from "vue";
import Vuex from "vuex";
import Meta from 'vue-meta'
import generalModule from "@/modules/shared/store";
import adminModule from "@/modules/admin/store";
import sharedModule from "@/modules/shared/store";
import alumnoModule from "@/modules/alumno/store";
import investigatorModule from "@/modules/investigator/store";
Vue.use(Meta);
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    general: generalModule,
    admin: adminModule,
    shared: sharedModule,
    alumno: alumnoModule,
    investigador: investigatorModule,
  },
});
